import _toConsumableArray from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { ArrayState } from "../state";
import { FilterBasedAccessor } from "./FilterBasedAccessor";
import { Utils } from "../support";
import { RangeQuery, BoolShould, RangeBucket, FilterBucket, FieldContextFactory } from "../";

var find = require("lodash/find");

var compact = require("lodash/compact");

var map = require("lodash/map");

var filter = require("lodash/filter");

var omitBy = require("lodash/omitBy");

var isUndefined = require("lodash/isUndefined");

var includes = require("lodash/includes");

export var NumericOptionsAccessor =
/*#__PURE__*/
function (_FilterBasedAccessor) {
  _inherits(NumericOptionsAccessor, _FilterBasedAccessor);

  function NumericOptionsAccessor(key, options) {
    var _this;

    _classCallCheck(this, NumericOptionsAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumericOptionsAccessor).call(this, key));
    _this.state = new ArrayState();
    _this.options = options;
    _this.options.options = Utils.computeOptionKeys(options.options, ["from", "to"], "all");
    _this.options.fieldOptions = _this.options.fieldOptions || {
      type: "embedded"
    };
    _this.options.fieldOptions.field = _this.options.field;
    _this.fieldContext = FieldContextFactory(_this.options.fieldOptions);
    return _this;
  }

  _createClass(NumericOptionsAccessor, [{
    key: "getDefaultOption",
    value: function getDefaultOption() {
      return find(this.options.options, function (it) {
        return isUndefined(it.from) && isUndefined(it.to);
      });
    }
  }, {
    key: "getSelectedOptions",
    value: function getSelectedOptions() {
      var keys = this.state.getValue();
      return filter(this.options.options, function (opt) {
        return includes(keys, opt.key);
      });
    }
  }, {
    key: "getSelectedOrDefaultOptions",
    value: function getSelectedOrDefaultOptions() {
      var selectedOptions = this.getSelectedOptions();
      if (selectedOptions && selectedOptions.length > 0) return selectedOptions;
      var defaultOption = this.getDefaultOption();
      if (defaultOption) return [defaultOption];
      return [];
    }
  }, {
    key: "setOptions",
    value: function setOptions(titles) {
      if (titles.length === 1) {
        this.state = this.state.clear();
        this.toggleOption(titles[0]);
      } else {
        var keys = map(filter(this.options.options, function (opt) {
          return includes(titles, opt.title);
        }), "key");
        this.state = this.state.setValue(keys);
        this.searchkit.performSearch();
      }
    }
  }, {
    key: "toggleOption",
    value: function toggleOption(key) {
      var option = find(this.options.options, {
        title: key
      });

      if (option) {
        if (option === this.getDefaultOption()) {
          this.state = this.state.clear();
        } else if (this.options.multiselect) {
          this.state = this.state.toggle(option.key);
        } else {
          this.state = this.state.setValue([option.key]);
        }

        this.searchkit.performSearch();
      }
    }
  }, {
    key: "getBuckets",
    value: function getBuckets() {
      return filter(this.getAggregations([this.uuid, this.fieldContext.getAggregationPath(), this.key, "buckets"], []), this.emptyOptionsFilter);
    }
  }, {
    key: "getDocCount",
    value: function getDocCount() {
      return this.getAggregations([this.uuid, this.fieldContext.getAggregationPath(), "doc_count"], 0);
    }
  }, {
    key: "emptyOptionsFilter",
    value: function emptyOptionsFilter(option) {
      return option.doc_count > 0;
    }
  }, {
    key: "buildSharedQuery",
    value: function buildSharedQuery(query) {
      var _this2 = this;

      var filters = this.getSelectedOptions();
      var filterRanges = map(filters, function (filter) {
        return _this2.fieldContext.wrapFilter(RangeQuery(_this2.options.field, {
          gte: filter.from,
          lt: filter.to
        }));
      });
      var selectedFilters = map(filters, function (filter) {
        return {
          name: _this2.translate(_this2.options.title),
          value: _this2.translate(filter.title),
          id: _this2.options.id,
          remove: function remove() {
            return _this2.state = _this2.state.remove(filter.key);
          }
        };
      });

      if (filterRanges.length > 0) {
        query = query.addFilter(this.uuid, BoolShould(filterRanges)).addSelectedFilters(selectedFilters);
      }

      return query;
    }
  }, {
    key: "getRanges",
    value: function getRanges() {
      return compact(map(this.options.options, function (range) {
        return omitBy({
          key: range.title,
          from: range.from,
          to: range.to
        }, isUndefined);
      }));
    }
  }, {
    key: "buildOwnQuery",
    value: function buildOwnQuery(query) {
      return query.setAggs(FilterBucket.apply(void 0, [this.uuid, query.getFiltersWithoutKeys(this.uuid)].concat(_toConsumableArray(this.fieldContext.wrapAggregations(RangeBucket(this.key, this.options.field, this.getRanges()))))));
    }
  }]);

  return NumericOptionsAccessor;
}(FilterBasedAccessor);